import BigNumber from "bignumber.js";

export const mint = async (spacemanContract: any, account: any, cnt: any) => {
  const temp = await spacemanContract.methods.mintPrice().call()
  const price = new BigNumber(temp)
  const amount = price.multipliedBy(cnt)
  return spacemanContract.methods.mintSpaceMan(cnt).send({ from: account, value: amount });
};
